import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { HttpMethods, SERVICES } from '../../services/api';
import apiAsyncThunkCreator from '../../services/apiAsyncThunkCreator';
import { IAccount } from './account';
import { ThunkAPI } from '../rootReducer';

export const fetchAccountById:AsyncThunk<{ account: IAccount }, string, ThunkAPI> = createAsyncThunk(
  'accounts/getById',
  (accountId: string, thunk) => {
    return apiAsyncThunkCreator<{ account: IAccount }, void>({
      endpoint: `accounts/${accountId}`,
      microservice: SERVICES.USERS_SERVICE,
      authenticated: true,
      method: HttpMethods.Get
    })(undefined, thunk);
  }
);
